import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=43894b74&scoped=true&"
import script from "./Add.vue?vue&type=script&lang=js&"
export * from "./Add.vue?vue&type=script&lang=js&"
import style0 from "./add.css?vue&type=style&index=0&id=43894b74&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43894b74",
  null
  
)

export default component.exports